<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Изменить значение
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-text">
                Введите желаемое значение системного параметра.
            </div>
            <div class="ap-modal-text">
                <span class="red-text bold-text">
                Внимание! Данное значение может серьёзно повлиять на работу приложения.
                Если не уверены - оставьте данное значение по умолчанию или проконсультируйтесь со специалистом!</span>
            </div>
            <div class="ap-modal-input-name">
                {{dataConfig.value.name}} <span class="red-text">*</span>
            </div>
            <input type="text" class="cd-modal-text-input" v-model="variableValue">
            <div class="form-alert-danger" v-show="showAlert === 'variableValue'">
                Обязательное поле!
            </div>
        </div>
        <div class="modal-button" v-on:click="submitAdd">
            {{dataConfig.SubmitButtonText}}
        </div>
    </div>
</template>

<script>
    import SVGModalClose from "../../SVG/SVGModalClose";
    import "vue-select/dist/vue-select.css";

    export default {
        name: "ModalChangeVariableValue",
        components: {
            SVGModalClose
        },
        props: {
            dataConfig: {
                type: Object
            }
        },
        data() {
            return {
                variableValue: '',
                showAlert: null
            }
        },
        methods: {
            async submitAdd() {
                if (this.variableValue) {
                    let data = {
                        'name': this.dataConfig.value.name,
                        'value': this.variableValue,
                        'default': this.dataConfig.value.default
                    }
                    await this.$store.dispatch('adminPanel/config/UPDATE_CONFIG', data);
                    this.$emit('close');
                } else {
                    this.showAlert = 'variableValue'
                }
            }
        },
        mounted() {
            if (this.dataConfig.value.value) {
                this.variableValue = this.dataConfig.value.value
            }
        }
    }
</script>

<style scoped>

</style>
